import React from "react";
import { Plane, MapPin, ArrowRightLeft, Users } from "lucide-react";
import LeadForm from "../components/LeadForm";
import Seo from "../components/Seo";

export default function Flights() {
  return (
    <div className="pt-24 lg:pt-28">
      <Seo title="Flight Booking" path="/flights" description="Lowest fares on domestic & international flights across 500+ airlines. Corporate rates, multi-city deals and unpublished fares with Acchajee Travels." />
      <section className="container-p">
        <span className="section-label">Flight Booking</span>
        <h1 className="h1 mt-3">Lowest fares · Domestic & International</h1>
        <p className="muted mt-4 max-w-2xl">Best deals across 500+ airlines. Get instant quotes on complex multi-city itineraries our team handles what online portals can't.</p>
      </section>

      <section className="container-p mt-10">
        <div className="card-glass p-6 md:p-8 grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
          <div className="md:col-span-2 flex items-center gap-3 bg-slate-50 rounded-xl px-4 py-3"><MapPin className="w-5 h-5 text-[#FF7D00]" /><div className="flex-1"><div className="text-[10px] uppercase tracking-widest muted">From</div><input placeholder="Delhi (DEL)" className="bg-transparent w-full text-sm font-medium outline-none" data-testid="flight-from" /></div></div>
          <div className="md:col-span-2 flex items-center gap-3 bg-slate-50 rounded-xl px-4 py-3"><ArrowRightLeft className="w-5 h-5 text-[#FF7D00]" /><div className="flex-1"><div className="text-[10px] uppercase tracking-widest muted">To</div><input placeholder="Dubai (DXB)" className="bg-transparent w-full text-sm font-medium outline-none" data-testid="flight-to" /></div></div>
          <a href="#flight-quote" className="btn-primary justify-center" data-testid="flight-search-btn"><Plane className="w-4 h-4 mr-2" /> Search Flights</a>
        </div>
      </section>

      <section className="section container-p">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="card-glass p-8">
            <Plane className="w-8 h-8 text-[#006CE4] mb-4" strokeWidth={1.5} />
            <h3 className="h3 mb-3">Domestic Flights</h3>
            <p className="muted">Delhi, Mumbai, Bangalore, Goa, Kochi, Srinagar, Port Blair — best fares across all major domestic routes. Special corporate & bulk rates.</p>
          </div>
          <div className="card-glass p-8">
            <Plane className="w-8 h-8 text-[#FF7D00] mb-4" strokeWidth={1.5} />
            <h3 className="h3 mb-3">International Flights</h3>
            <p className="muted">Business class, premium economy, multi-city, stopover deals. We access unpublished fares that portals don't show.</p>
          </div>
        </div>
      </section>

      <section className="container-p pb-20" id="flight-quote">
        <div className="card-glass p-8 md:p-12"><LeadForm title="Get lowest flight fares" source="flights" /></div>
      </section>
    </div>
  );
}
